export class CoachLogicError extends Error {
  constructor(message) {
    super();
    this.message = message;
  }
}

export class HTTPServerError extends CoachLogicError {
  constructor(message, { status }) {
    super();
    this.message = message;
    this.status = status;
  }
}
